export const SLATE = {
	50: "#f8fafc",
	100: "#f1f5f9",
	150: "#e8edf3",
	200: "#e2e8f0",
	300: "#cbd5e1",
	400: "#94a3b8",
	500: "#64748b",
	600: "#475569",
	700: "#334155",
	800: "#1e293b",
	900: "#0f172a",
} as const;

export const BLUE = {
	50: "#eff6ff",
	100: "#dbeafe",
	200: "#bfdbfe",
	500: "#3b82f6",
	600: "#2563eb",
	700: "#1d4ed8",
	800: "#1e40af",
} as const;

export const PURPLE = {
	50: "#faf5ff",
	100: "#f3e8ff",
	400: "#c084fc",
	500: "#a855f7",
	600: "#9333ea",
	700: "#7e22ce",
} as const;

export const EMERALD = {
	50: "#ecfdf5",
	100: "#d1fae5",
	500: "#10b981",
	600: "#059669",
} as const;

export const ROSE = {
	50: "#fff1f2",
	500: "#f43f5e",
	600: "#e11d48",
} as const;

export const AMBER = {
	50: "#fffbeb",
	100: "#fef3c7",
	200: "#fde68a",
	300: "#fcd34d",
	500: "#f59e0b",
	600: "#d97706",
	700: "#b45309",
	800: "#92400e",
} as const;

export const RED = {
	50: "#fef2f2",
	100: "#fee2e2",
	500: "#ef4444",
	700: "#b91c1c",
} as const;

export const RADIUS = {
	md: "8px",
	lg: "12px",
	xl: "16px",
	"2xl": "20px",
	"3xl": "24px",
	full: "9999px",
} as const;

export const EYEBROW_SX = {
	fontSize: 10,
	fontWeight: 700,
	letterSpacing: "0.12em",
	textTransform: "uppercase",
	color: SLATE[400],
} as const;

export const SECTION_EYEBROW_SX = {
	fontSize: 12,
	fontWeight: 600,
	letterSpacing: "0.08em",
	textTransform: "uppercase",
	color: SLATE[400],
} as const;
